import React from "react";
import {
  QrCode,
  Images,
  Map,
  Users,
  Bell,
  BarChart3,
  MessageCircle,
  CreditCard,
} from "lucide-react";
import { FEATURES } from "../../mock";
import Reveal from "./Reveal";

const ICONS = {
  qr: QrCode,
  images: Images,
  map: Map,
  users: Users,
  bell: Bell,
  chart: BarChart3,
  chat: MessageCircle,
  card: CreditCard,
};

const Features = () => (
  <section id="ozellikler" className="bg-white/90 backdrop-blur-md">
    <div className="max-w-6xl mx-auto px-6 py-20">
      <Reveal>
        <div className="text-center">
          <div className="text-[11px] tracking-[0.3em] font-semibold text-neutral-400">
            ÖZELLİKLER
          </div>
          <h2 className="mt-3 text-3xl font-bold text-black">
            Uygulamada olan her şey
          </h2>
        </div>
      </Reveal>

      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {FEATURES.map((f, i) => {
          const Icon = ICONS[f.icon];
          return (
            <Reveal key={f.title} delay={i * 60}>
              <div className="bg-[#f5f5f5] rounded-2xl p-5 h-full hover:bg-[#efefef] hover:-translate-y-1 transition-[background-color,transform] duration-300">
                <div className="bg-white rounded-xl w-10 h-10 flex items-center justify-center shadow-sm">
                  <Icon className="w-5 h-5 text-black" strokeWidth={1.8} />
                </div>
                <div className="mt-4 text-sm font-bold text-black">
                  {f.title}
                </div>
                <p className="mt-1.5 text-[11px] leading-4 text-neutral-500">
                  {f.desc}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Features;
